import {Doughnut, mixins} from 'vue-chartjs'
import * as ChartJsPluginDataLabels from 'chartjs-plugin-doughnutlabel'
const {
  reactiveProp
} = mixins
export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options', 'styles'],
  mounted () {
    this.addPlugin(ChartJsPluginDataLabels)
    this.renderChart(this.chartData, this.options)
  }
}
